module.exports = __webpack_public_path__ + "static/media/rateit.758ac513.png";